import { render, staticRenderFns } from "./contractsView.vue?vue&type=template&id=3bdc8800&functional=true&"
import script from "./contractsView.vue?vue&type=script&lang=js&"
export * from "./contractsView.vue?vue&type=script&lang=js&"
import style0 from "./contractsView.vue?vue&type=style&index=0&id=3bdc8800&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports